import { useState } from 'react';
import { useConnect } from '@lore/query-connect';
import queryString from 'query-string';
import moment from 'moment-timezone';
import getQueryUtils, { attributeKeys } from '@/pages/evaluations-event-educators/queryUtils.photos';

export default function useQuery(props) {
  const {
    search = {},
    pageSize = 10,
    network,
    schoolStart,
    schoolEnd
  } = props;

  const [timestamp] = useState(moment().toISOString());

  const queryUtils = getQueryUtils(search, attributeKeys, timestamp);

  return useConnect('upload.find', {
    where: {
      eager: {
        $where: {
          $and: [...queryUtils.where],
          evaluationEventEducatorId: {
            $null: false
          },
          evaluationEventEducator: network?.id ? {
            $where: {
              event: {
                $where: {
                  networkId: network.id
                }
              }
            }
          } : undefined,
          createdAt: {
            $lte: schoolEnd,
            $gte: schoolStart
          }
        }
      }
    },
    pagination: {
      page: queryString.parse(location.search).page || '1',
      pageSize: pageSize,
      order: search.order || 'createdAt desc'
    }
  }, {
    keepPreviousData : true
  });
}
